export enum ECapability {
  // Base
  PcManagement = 'pc_management',
  CashRegister = 'cash_register',
  ZonesRatesPasses = 'zones_rates_passes',
  LoyaltyProgram = 'loyalty_program',
  NewsWidget = 'news_widget',
  GamesLibrary = 'games_library',
  LicensePool = 'license_pool',
  ContentRestrictions = 'content_restrictions',
  Reports = 'reports',
  MobileApp = 'mobile_app',

  // Business (Base +)
  Booking = 'booking',
  BonusBalance = 'bonus_balance',
  // SHOP covers: Shop in Shell (orders) + CAP shop (goods/services/dashboards) + Combo
  Shop = 'shop',
  PaymentIntegrations = 'payment_integrations',
  RemoteAccess = 'remote_access',

  // Premium (Business +)
  GameUpdate = 'game_update',
  ExecutiveDashboard = 'executive_dashboard',
  SenetBoot = 'senet_boot',
  AllIntegrations = 'all_integrations',
}
